import { FieldArray, Field } from "formik";
import SubHeading from "../../atoms/SubHeading";

const AirbnbSection = ({ values, setFieldValue }) => {
    return (
        <div className="w-full flex flex-col border border-gray-500 bg-gray-100 p-4 rounded-md">
            <div className="w-full flex justify-between mb-4">
                <SubHeading text="Respaldos Airbnb" color="black" />
                <button
                    type="button"
                    className="bg-blue-500 text-white px-2 py-1 rounded"
                    onClick={() =>
                        setFieldValue("airbnbDocuments", [
                            ...values?.airbnbDocuments,
                            { nameService: "", file: null }
                        ])
                    }
                >
                    + Agregar
                </button>
            </div>
            <FieldArray name="airbnbDocuments">
                {({ remove }) => (
                    <>
                        {values?.airbnbDocuments?.map((doc, index) => (
                            <div key={index} className="w-full grid grid-cols-4 gap-3 items-center mb-2 bg-white p-2 rounded-lg">
                                <Field
                                    name={`airbnbDocuments.${index}.nameService`}
                                    placeholder="Nombre del servicio"
                                    className="border px-2 py-1 rounded w-full"
                                />
                                <input
                                    type="file"
                                    onChange={(e) => {
                                        const file = e.currentTarget.files?.[0] || null;
                                        setFieldValue(`airbnbDocuments.${index}.file`, file);
                                    }}
                                    className="w-full col-span-2"
                                />
                                <button
                                    type="button"
                                    className="bg-red-500 text-white px-2 py-1 rounded"
                                    onClick={() => remove(index)}
                                >
                                    Eliminar
                                </button>
                            </div>
                        ))}
                    </>
                )}
            </FieldArray>
        </div>
    );
};

export default AirbnbSection;
